export class LogoutError extends Error {

	constructor() {
		super('There was a problem while logging out.')
		this.name = 'LogoutError';

		Object.setPrototypeOf(this, LogoutError.prototype);
	}
}
